import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useSport } from '../contexts/SportContext';
import './SportArcSlider.css';

const SportArcSlider = ({ onSelect, initialSportKey }) => {
    const { sportTypes } = useSport();
    const sportArray = Object.values(sportTypes);
    const initialIndex = initialSportKey ? sportArray.findIndex(s => s.key === initialSportKey) : 0;
    const [activeIndex, setActiveIndex] = useState(initialIndex >= 0 ? initialIndex : 0);
    const [direction, setDirection] = useState(0);

    useEffect(() => {
        onSelect(sportArray[activeIndex].key, sportArray[activeIndex].name);
    }, [activeIndex, onSelect, sportArray]);

    const goNext = () => {
        setDirection(1);
        setActiveIndex((prev) => (prev + 1) % sportArray.length);
    };

    const goPrev = () => {
        setDirection(-1);
        setActiveIndex((prev) => (prev - 1 + sportArray.length) % sportArray.length);
    };

    const variants = {
        enter: (dir) => ({ x: dir > 0 ? 100 : -100, opacity: 0, scale: 0.8 }),
        center: { x: 0, opacity: 1, scale: 1 },
        exit: (dir) => ({ x: dir < 0 ? 100 : -100, opacity: 0, scale: 0.8 })
    };

    return (
        <div className="arc-slider-container-v2">
            <button onClick={goPrev} className="arc-nav-button arc-nav-left">‹</button>
            <div className="arc-slider-viewport">
                <motion.div
                    key={activeIndex}
                    custom={direction}
                    variants={variants}
                    initial="enter"
                    animate="center"
                    exit="exit"
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                    className="arc-card-v2"
                >
                    <div className="arc-emoji-v2">{sportArray[activeIndex].icon}</div>
                    <div className="arc-name-v2">{sportArray[activeIndex].name}</div>
                </motion.div>
            </div>
            <button onClick={goNext} className="arc-nav-button arc-nav-right">›</button>
        </div>
    );
};

export default SportArcSlider;
